export const DEFAULT_LANGUAGE_ISO_CODE = "en";
export const DEFAULT_LANGUAGE = "english";

export const LIMIT_OPEN_SEARCH_MONTHS = 1;

export enum AnalysisTimePeriod {
    Yesterday = "Yesterday",
    Last7Days = "Last7Days",
}

export const ANALYSIS_TIME_PERIOD_LABELS: Record<AnalysisTimePeriod, string> = {
    [AnalysisTimePeriod.Yesterday]: "Yesterday",
    [AnalysisTimePeriod.Last7Days]: "Last 7 Days",
};
